












import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {AlertType} from "../model/enum/alert.enum";
import {AlertData} from "../model/interface/alertData.interface";

@Component
export default class Alert extends Vue {
    @Prop(Object) alertData!: AlertData;
    private type: string = AlertType[this.alertData.type].toUpperCase();
    private showDialog: boolean = true;
}
